import { render, staticRenderFns } from "./PicturesForm.vue?vue&type=template&id=191ac96a&"
import script from "./PicturesForm.vue?vue&type=script&lang=js&"
export * from "./PicturesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports